interface ApiErrorLike {
  response?: {
    data?: {
      message?: unknown;
    };
  };
}

/**
 * Extrai a mensagem PT-BR enviada pelo backend (400 do NestJS). Retorna null
 * quando não há mensagem utilizável — o chamador exibe o alerta genérico.
 */
export function getApiErrorMessage(error: unknown): string | null {
  const message = (error as ApiErrorLike)?.response?.data?.message;

  if (typeof message === "string" && message.trim() !== "") return message;

  if (Array.isArray(message)) {
    const parts = message.filter(
      (part): part is string => typeof part === "string" && part.trim() !== ""
    );
    if (parts.length > 0) return parts.join(" ");
  }

  return null;
}

// Blob.text() não existe em ambientes mais antigos (ex.: jsdom dos testes) —
// FileReader cobre esses casos.
function readBlobText(blob: Blob): Promise<string> {
  if (typeof blob.text === "function") return blob.text();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
}

/**
 * Variante para requisições com responseType 'blob' (exportações): o axios
 * devolve o corpo do erro como Blob, então o JSON precisa ser lido antes de
 * extrair a mensagem.
 */
export async function getBlobApiErrorMessage(
  error: unknown
): Promise<string | null> {
  const data = (error as { response?: { data?: unknown } })?.response?.data;

  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await readBlobText(data));
      return getApiErrorMessage({ response: { data: parsed } });
    } catch {
      return null;
    }
  }

  return getApiErrorMessage(error);
}
